// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__deVeY","log":"ModalInventoryLogs_log__2HK9y","date":"ModalInventoryLogs_date__3aG-7","userName":"ModalInventoryLogs_userName__39Sfj"};